import React from 'react'
import UtilitiesHeader from './UtilitiesHeader'
import UtilitiesInner from './UtilitiesInner'
export const utilitiesControllerContext = React.createContext()

function useUtilitiesController(props) {

  const obj = { }

  return (obj)
}

function UtilitiesController(props) {
  const utilitiesController = useUtilitiesController(props)
  return (
    <React.Fragment>
      <utilitiesControllerContext.Provider value={utilitiesController}>
        <UtilitiesHeader />
        <UtilitiesInner />
      </utilitiesControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(UtilitiesController)
